//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    quantum: {
      type: String,
      default: ''
    },
    dataDetail: {
      type: Object,
      default: {}
    }
  }
};